export type DelayOptions = {
  minMs?: number;
  extraMs?: number;
};

export const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));

export async function withMinDuration<T>(
  work: () => Promise<T>,
  options: DelayOptions = {},
): Promise<T> {
  const {minMs = 450, extraMs = 0} = options;

  const start = performance.now();

  try {
    const result = await work();

    const elapsed = performance.now() - start;
    const remaining = minMs + extraMs - elapsed;

    if (remaining > 0) {
      await sleep(remaining);
    }

    return result;
  } catch (err) {
    const elapsed = performance.now() - start;
    const remaining = minMs + extraMs - elapsed;

    if (remaining > 0) {
      await sleep(remaining);
    }

    throw err;
  }
}
